var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popover-box",style:({'width': (_vm.width + "px"), 'min-height': (_vm.height + "px"), 'left': ("-" + ((_vm.width/2) - 12) + "px")})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }